export const DEFAULT_MSG_LENGTH = 5000
export const NO_SESSION_ERROR = "No session found.  Refresh and try again."